import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkpoints"
export default class extends Controller {
  static values = {
    checkpoint: Number,
    user: Number,
    check: Number,
    event: Number,
  };

  declare checkpointValue: number;
  declare hasCheckpointValue: boolean;
  declare userValue: number;
  declare hasUserValue: boolean;
  // declare checkValue: number;
  // declare hasCheckValue: boolean;
  declare eventValue: number;
  declare hasEventValue: boolean;

  connect() {
    console.log(this.scope.element);
  }

  check() {
    let params = {
      user_id: this.userValue,
    };
    if (!this.hasCheckValue || this.checkValue == 0) {
      fetch(`/events/${this.eventValue}/checkpoints/${this.checkpointValue}/check`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        },
        body: JSON.stringify(params),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((json) => {
          console.log(json);
        });
    }
  }
}
